import { render, staticRenderFns } from "./testimonials.vue?vue&type=template&id=7657f4f8&scoped=true"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"
import style0 from "./testimonials.vue?vue&type=style&index=0&id=7657f4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7657f4f8",
  null
  
)

export default component.exports